import React from 'react';
import { HorizontalScroll, Box, StyledLink, StyledSpan } from './styles';
import { useViewportContext } from 'src/components/viewport/context';
import { useAppContext } from 'src/components/app-context';
import {
  InternalNavigationScope,
  trackInternalNavigationClick,
} from 'src/globals/tracking/tracking';

type Props = {
  recentSearches: string[];
};

export const RecentSearches = (props: Props) => {
  const { recentSearches } = props;
  const { isMobile } = useViewportContext();
  const { t } = useAppContext();

  if (!recentSearches || !recentSearches.length) return null;

  const renderRecentSearches = () => (
    <>
      <StyledSpan>{t('search', 'search.your-searches')}</StyledSpan>
      {recentSearches.map(recentSearch => {
        const url = `/search?search=${encodeURIComponent(recentSearch)}`;
        return (
          <StyledLink
            href={url}
            key={recentSearch}
            onClick={() =>
              trackInternalNavigationClick({
                scope: InternalNavigationScope.RECENT_SEARCHES_HERO,
                nextPage: url,
              })
            }
          >
            {recentSearch}
          </StyledLink>
        );
      })}
    </>
  );

  const renderMobile = () => {
    return (
      <HorizontalScroll showArrows={false}>
        {renderRecentSearches()}
      </HorizontalScroll>
    );
  };

  const renderDesktop = () => {
    return <Box>{renderRecentSearches()}</Box>;
  };

  return isMobile ? renderMobile() : renderDesktop();
};
